import { OrderedMap } from 'immutable';

export const FILTERS_INFO = Object.freeze({
  owners: Object.freeze({
    name: 'Owner',
  }),
  builds: Object.freeze({
    name: 'Build',
    search: true,
  }),
  oses: Object.freeze({
    name: 'OS',
  }),
  browsers: Object.freeze({
    name: 'Browser',
  }),
  tags: Object.freeze({
    name: 'Tag',
    search: true,
  }),
});

export const FILTERS_MAP = OrderedMap({
  owners: FILTERS_INFO.owners,
  builds: FILTERS_INFO.builds,
  oses: FILTERS_INFO.oses,
  browsers: FILTERS_INFO.browsers,
  tags: FILTERS_INFO.tags,
});

export const OVERVIEW_FILTERS_MAP = OrderedMap({
  owners: FILTERS_INFO.owners,
  builds: FILTERS_INFO.builds,
  oses: FILTERS_INFO.oses,
  browsers: FILTERS_INFO.browsers,
});

export const CONCURRENCY_FILTERS_MAP = OrderedMap({
  owners: FILTERS_INFO.owners,
});
